export const ALL_TEACHERS_ID = 0;



// WEBPACK FOOTER //
// ./containers/participation/participation-constants.js